<template>
    <div class="results">
        <div v-for="question of questions" :key="question.title" class="results__question-item">
            <div class="results__question">{{ question.title }}</div>
            <div class="results__user">
                <img src="@/assets/images/expert-panel/user.svg" />
                ответ участника
            </div>
            <div class="results__answer" v-html="question.value" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExpertPanelReviewResults',
    props: {
        data: Array,
    },
    computed: {
        questions() {
            const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;
            return this.data ? this.data
                    .filter((row) => row.name === undefined)
                    .map((row) => ({...row, value: row.value.replace(exp, '<a href="$1" target="_blank">$1</a>')}))
                : [];
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.results {
  display: flex;
  flex-direction: column;
  gap: rem(32);

  font-family: Montserrat, sans-serif;

  &__question {
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(24);
    color: #131614;
  }
  &__user {
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(22);
    color: #98A0A9;
    margin: rem(16) 0;
  }
  &__answer {
    background: #F6FAFD;
    border-radius: rem(16);
    padding: rem(16);
    font-weight: 400;
    font-size: rem(16);
    line-height: rem(22);
    color: #131614;
    :deep(a) {
      text-decoration: underline;
    }
  }
}
</style>